import { Box, Button, Typography } from "@mui/material";
import React from "react";
import ServiceTypesHeader from "./ServiceTypesHeader";
import ServiceTypeList from "./ServiceTypeList";

const ServiceTypesForm = ({
  addNewServiceType,
  serviceTypes,
  setServiceTypes,
  edit,
  fetchedServiceTypes,
  setServiceTypeIdsToDelete,
  isDefault = false // NEW: Added isDefault prop
}) => {
  return (
    <div>
      <ServiceTypesHeader btnOnClick={addNewServiceType} />
      <ServiceTypeList
        list={serviceTypes}
        setServiceTypes={setServiceTypes}
        fetchedServiceTypes={fetchedServiceTypes}
        edit={edit}
        setServiceTypeIdsToDelete={setServiceTypeIdsToDelete}
        isDefault={isDefault} // NEW: Pass isDefault to list
      />
    </div>
  );
};

export default ServiceTypesForm;
